const MainContainer = ({ children }) => {
  return (
    <main className='' id='main-content'>
      {children}
    </main>
  )
}

export default MainContainer
